<template>
    <div class="row heading justify-content-center mb-5 mt-5">
        <div class="col">
            <h1 class="section-highlights headings serif">{{headingData.name}}</h1>
            <span class="h-line"></span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'headingData'],
        data() {
            return {

            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.heading{
        span.h-line{
            display:inline-block;
            border-top:0.3rem solid;
            border-bottom:0.3rem solid;
            border-radius:0.6rem;
            width:100%;
        }
    }
</style>